import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useLang } from "./LanguageContext";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [impersonating, setImpersonating] = useState(!!localStorage.getItem("ts_admin_token"));
  const langCtx = useLang();

  // Follow the user's email language: Swedish users get a Swedish interface automatically.
  useEffect(() => {
    if (user?.language === "sv" && langCtx?.lang !== "sv") langCtx?.setLang("sv");
  }, [user?.language]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithToken = (token, userData) => {
    localStorage.removeItem("ts_admin_token");
    setImpersonating(false);
    if (token) localStorage.setItem("ts_token", token);
    setUser(userData);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("ts_token");
    localStorage.removeItem("ts_admin_token");
    setImpersonating(false);
    setUser(null);
  };

  const impersonate = (token, userData) => {
    const current = localStorage.getItem("ts_token");
    if (current) localStorage.setItem("ts_admin_token", current);
    localStorage.setItem("ts_token", token);
    setImpersonating(true);
    setUser(userData);
  };

  const stopImpersonating = () => {
    const adminTok = localStorage.getItem("ts_admin_token");
    if (adminTok) {
      localStorage.setItem("ts_token", adminTok);
      localStorage.removeItem("ts_admin_token");
    }
    setImpersonating(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, loginWithToken, logout, impersonating, impersonate, stopImpersonating }}>
      {children}
    </AuthContext.Provider>
  );
};
